module.exports = __webpack_public_path__ + "img/icon-school9.a4027ea5.png";